const light = {
  pay_button_label: "pay",
  theme: "light",
  font_family: "SF-UI-Text",
  hover_text_color: "#0055cc",
  primary_text_color: "#0055cc",
  regular_text_color: "#2d3440",
  placeholder_text_color: "#d7d9dc",
  base_border_color: "#d7d9dc",
  border_radius: '4px',
  primary_background_color: "#fff",
  secondary_background_color: "#f8f9fa",
  secondary_text_color: "#b4b5b8",
  primary_button_color_base: "#13c04c",
  primary_button_color_hover: "#36d951",
  primary_button_color_active: "#10a642",
  secondary_button_color_base: "#0055cc",
  secondary_button_color_hover: "#00a2f3",
  secondary_button_color_active: "#3d6399",
  active_text_color: "#0055cc",

  primary_font_color: "#2d3440",
  easing: ".2s ease",

  primary: "#6200EE",
  primary_variant: "#3700B3",
  secondary: "#03DAC6",
  secondary_variant: "#018786",
  background: "#FFFFFF",
  surface: "#FFFFFF",
  error: "#B00020",
  on_primary: "#FFFFFF",
  on_secondary: "#000000",
  on_background: "#000000",
  on_surface: "#000000",
  on_error: "#FFFFFF",
};

const basic = {
  primary: "#0055cc",
  primary_variant: "#013a89",
  primary_text_color: "#000",
  primary_background_color: "#fff",
  on_primary_color: "#FFF",

  secodary: "#0055cc",
  secondary_variant: "#0055cc",
  secondary_text_color: "#2d3440",
  secondary_background_color: "#fff",
  on_secondary_color: "#000",

  placeholder_text_color: "#b4b5b8",
  font_family: "SF-UI-Text",

  success_color: "#67C23A",
  warning_color: "#E6A23C",
  danger_color: "#F56C6C",
  info_color: "#909399",

  // Not getting from props
  border: "1px solid ",
  border_radius: "4px",
  box_shadow: "0 1px 1px 0 rgba(215,216,219,.5)",
  box_shadow_hover: "0 5px 10px 0 rgba(45,52,64,.2)",
  border_color: "rgba(215,217,220,.5)",
  secondary_border_color: "none",
  default_transition: "all .25s ease",
  box_shadow_inset: "inset 0 1px 1px 0 rgba(0, 0, 0, 0.1)",

  primary: "#0055cc",
  primary_variant: "#3700B3",
  secondary: "#2d3440",
  secondary_variant: "#03DAC6",

  background: "#fff",
  surface: "#fff",

  error: "#e65639",
  on_primary: "#fff",
  on_secondary: "#fff",

  on_background: "#000",
  on_surface: "#000",
  on_error: "#fff",

  success : "#67C23A",
  on_success: "#FFF",
};

const dark = {
  primary_background_color: "#000",
  secondary_background_color: "#666",

  primary: "#FFF",
  primary_variant: "rgb(0, 85, 204)",
  on_primary_color: "#333",

  secodary: "#2d2d2d",
  secondary_variant: "#323232",
  on_secondary_color: "#000",

  primary_text_color: "#fff",
  secondary_text_color: "rgba(255, 255, 255, 0.2)",
  placeholder_text_color: "rgba(255, 255, 255, 0.2)",

  success_color: "#67C23A",
  warning_color: "#E6A23C",
  danger_color: "#F56C6C",
  info_color: "#909399",

  border: "none",
  border_radius: "4px",

  box_shadow: "none",
  box_shadow_inset: " inset 0 1px 1px 0 rgba(0, 0, 0, 0.1);",
  box_shadow_hover: "0 5px 10px 0 rgba(45,52,64,.2)",

  border_color: "#909090",
  secondary_border_color: "none",

  default_transition: "all .25s ease",
  font_family: "SF-UI-Text",
  amount_text_weight: "bold",

  primary: "#BB86FC",
  primary_variant: "#3700B3",
  secondary: "#03DAC6",
  secondary_variant: "#03DAC6",
  background: "#121212",
  surface: "#2C2C2C",

  error: "#CF6679",
  on_primary: "#000",
  on_secondary: "#000",

  on_background: "#fff",
  on_surface: "#fff",
  on_error: "#000",
};

const display = {
  hide_header: false,
  hide_footer: false,
  hide_progress_bar: false,
  hide_filter_bar: false,
  hide_lifetime_counter: false,
  disable_geo_filter: false,
  reduce_motion: false,
};

const defaultTheme = basic;

export { defaultTheme, light, dark, display, basic };

export default {
  defaultTheme,
  light,
  dark,
  display,
  basic,
};
